Date.isLeapYear = function(year) {
	return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
};

Date.getDaysInMonth = function(year, month) {
	return [31, (Date.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
};

Date.prototype.isLeapYear = function() {
	return Date.isLeapYear(this.getFullYear());
};

Date.prototype.getDaysInMonth = function() {
	return Date.getDaysInMonth(this.getFullYear(), this.getMonth());
};

Date.prototype.addMonths = function(value) {
	var n = this.getDate();
	this.setDate(1);
	this.setMonth(this.getMonth() + value);
	this.setDate(Math.min(n, this.getDaysInMonth()));
	return this;
};
import store from "@/store/store";
const moment = require("moment");
require("moment/locale/fr");
export default {
	methods: {

		getTableHeight() {
			return (store.state.windowHeigth-store.state.horizentalNavBarHeight)-store.state.filterCardHeight-(0.17*store.state.windowHeigth);
		},
		/**
		 * Compare 2 values to get the difference in percent (%)
		 * @param {number} value1 - A number value
		 * @param {number} value2 - A second number value to compare with the first one to get a percent
		 * @return {string} Return a string representing the difference
		 */
		getDiffPercent: (value1, value2) => {
			let startRes = "";
			let finalRes = "";
			let result =
        ((parseFloat(value1) - parseFloat(value2)) / parseFloat(value2)) * 100;
			if(isNaN(result)) {
				if(result > 0) {
					startRes = "+";
					finalRes = startRes.concat(result.toFixed(0).toString());
				}
				if(result < 0) {
					finalRes = parseFloat(result)
						.toFixed(0)
						.toString();
				}
				else{
					result = 0;
					finalRes = result.toFixed(0).toString();
				}
			}
			if(result > 0 && !isNaN(result)) {
				startRes = "+";
				finalRes = startRes.concat(result.toFixed(0).toString());
			}
			if(result == Infinity) {
				result = "∞";
				finalRes = startRes.concat(result);
			}
			else{
				finalRes = startRes.concat(
					parseFloat(result)
						.toFixed(0)
						.toString()
				);
			}
			return finalRes;
		},

		/**
		 * Format a int value depend on number digits needed
		 * @param {number} value - Value to format
		 * @param {number} limit - Number of digits after the decimal point,
		 * @return {number} Return the formated to value
		 */
		formatValue: (value, limit) => {
			if(limit == null) {
				limit = 2;
			}
			let val = value / 1;
			return Number(val).toFixed(limit);
		},

		/**
		 * Convert millisecond to minut + second
		 * @param {number} millis - MS to convert
		 * @return {string} return the time in string format (xx:yy)min
		 */
		formatMsToMinuts: millis => {
			let minutes = Math.floor(millis / 60);
			let seconds = (millis % 60).toFixed(0);
			let final = minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
			return final.toString();
		},

		/**
		 * Calculates a percent using a value and a total
		 * @param {number} value - Value to compare
		 * @param {number} total - Total that will be used to calculate the percent
		 * @return {number} return a value in percent
		 */
		getValueInPercent: (value, total) => {
			let totalValue = parseFloat(total);
			let percent = 0;
			percent = (parseFloat(value) * 100) / totalValue;
			return percent.toFixed(2);
		},

		/**
		 * Retrieve the difference between 2 values
		 * @param {number} value1 - A number value
		 * @param {number} value2 - A second number value that will be substract to the first one
		 * @return {number} return the difference
		 */
		getSign: (value1, value2) => {
			let result = 0;
			result = parseFloat(value1) - parseFloat(value2);
			return result;
		},

		/**
		 * Substract one year of the date given
		 * @param {string} date - format given ("yyyy-MM-dd")
		 * @return {string} returns the date with one year off
		 */
		getDateOneYearOff: date => {
			let newDate = date.split("-");
			newDate[0] = (parseInt(newDate[0]) - 1).toString();
			return newDate.join("-");
		},

		/**
		 * Substract 6 months of the date given
		 * @param {string} date - Date with this format (yyyy-MM-dd)
		 * @return {string} returns the date with one year off | format ("yyyy-MM-dd")
		 */
		getDateSixMonthsOff: date => {
			let splitDate = date.split("-");
			let newDate = new Date(
				Date.UTC(splitDate[0], splitDate[1] - 7, splitDate[2])
			); // Since javascript month is 0 based we substract 7 to the month to remove 6 months (eg: 0 = january , 1 = february)
			return newDate.toISOString().slice(0, 10);
		},

		/**
		 * Converts universal date format to french format
		 * @param {string} date - Date with this format (yyyy-MM-dd)
		 * @return {string} returns the date the french format | format ("dd-MM-yyyy")
		 */
		formatDate: date => {
			let splitDate = date.split("-");
			let newDate = splitDate.reverse();
			return newDate;
		},

		/**
		 * Remove all spaces in a string
		 * @param {string} value - value to use
		 * @return {string} returns string without whitespaces
		 */
		removeSpace: value => {
			return value.toString().replace(" ", "");
		},

		/**
		 * Format a int value adding a space every 3 numbers
		 * @param {number} value - Value to format
		 * @return {string} Return the formated to value to string format
		 */
		formatThousandNumb: value => {
			return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "\u00a0") : "0"; // \u00a0 refers to &nbsp
		},

		/**
		 * Format a string to be shorter or equal to the limit given
		 * @param {string} string the string to format
		 * @param {number} limit limit length of the string
		 * @return {string} Return the formated string
		 */
		formatString: (string, limit) => {
			let finalString = string;
			if(finalString.length > limit) {
				finalString = string.substring(0, limit) + "...";
			}
			return finalString;
		},

		getDateWithDuration: (date, duration) => {
			let dateObject = new Date(date);
			dateObject.addMonths(duration);
			// let strDate = dateObject.toISOString().substring(0, 10).split('-').reverse().join('/')
			return dateObject.toISOString().substring(0, 10);
		},

		/**
		 * Format a date to french format (eg: dd/MM/yyyy)
		 * @param {Date} date - date from other format than french (ex: yyyy-MM-dd)
		 * @return {Date} date to french format
		 */
		getDateToFrenchFormat: date => {
			try{
				if(date == null) {
					return " ";
				}
				else{
					let temp = new Date(date);
					const ye = new Intl.DateTimeFormat("fr", {year: "2-digit"}).format(temp);
					const mo = new Intl.DateTimeFormat("fr", {month: "2-digit"}).format(temp);
					const da = new Intl.DateTimeFormat("fr", {day: "2-digit"}).format(temp);
					return `${da}/${mo}/${ye}`;
				}
			}
			catch(e){
				return " ";
			}
		},

		/**
		 * Format a date to french format (eg: dd/MM/yyyy)
		 * @param {Date} date - date from other format than french (ex: yyyy-MM-dd)
		 * @return {Date} date to french format
		 */
		getDateToFrenchFormatFourDigit: date => {
			if(date == null) {
				return " ";
			}
			else{
				let temp = new Date(date);
				const ye = new Intl.DateTimeFormat("fr", {year: "numeric"}).format(temp);
				const mo = new Intl.DateTimeFormat("fr", {month: "2-digit"}).format(temp);
				const da = new Intl.DateTimeFormat("fr", {day: "2-digit"}).format(temp);
				return `${da}/${mo}/${ye}`;
			}
		},

		/**
		 * Format a date to ISO format (eg: yyyy-mm-dd)
		 * @param {Date} date - date from french format (ex: dd/mm/yyyy)
		 * @return {Date} date to ISO format
		 */
		getDateFromFrenchToISOFormat: date => {
			if(date == null) {
				return " ";
			}
			else{
				let temp = new Date(date).toISOString();
				return temp;
			}
		},

		getMonthName: date => {
			let month = date.getMonth();
			switch(month.toString()) {
			case"0": {
				return "janvier";
			}
			case"1": {
				return "février";
			}
			case"2": {
				return "mars";
			}
			case"3": {
				return "avril";
			}
			case"4": {
				return "mai";
			}
			case"5": {
				return "juin";
			}
			case"6": {
				return "juillet";
			}
			case"7": {
				return "août";
			}
			case"8": {
				return "septembre";
			}
			case"9": {
				return "octobre";
			}
			case"10": {
				return "novembre";
			}
			case"11": {
				return "décembre";
			}
			default: {
				return "Non\u00a0renseigné";
			}
			}
		},

		getMonthFrench: month => {
			month = month < 0 ? month + 12 : month;
			switch(month.toString()) {
			case"0": {
				return "Janvier";
			}
			case"1": {
				return "Février";
			}
			case"2": {
				return "Mars";
			}
			case"3": {
				return "Avril";
			}
			case"4": {
				return "Mai";
			}
			case"5": {
				return "Juin";
			}
			case"6": {
				return "Juillet";
			}
			case"7": {
				return "Août";
			}
			case"8": {
				return "Septembre";
			}
			case"9": {
				return "Octobre";
			}
			case"10": {
				return "Novembre";
			}
			case"11": {
				return "Décembre";
			}
			default: {
				return "";
			}
			}
		},
		/**
		 * Convert to french format
		 * @param {String} date - MM/YYYY
		 * @returns {String} - MMMM YYYY
		 */
		getInMonth: (date) => {
		// Use moment to parse the date
			const dateMoment = moment(date, "MM/YYYY");

			// Get the month
			const month = dateMoment.format("MMMM").charAt(0).toUpperCase() + dateMoment.format("MMMM").slice(1);;

			// Get the year
			const year = dateMoment.format("YYYY");

			// Concatenate month and year
			const formattedDate = `${month} ${year}`;
			return formattedDate;

		},

		/**
		 * Remove url prefix : "http(s)://www." from url String variable
		 * Regex : /(http(s?)://)?(www\.)?/
		 * @param {string} url - URL to remove prefix
		 * @return {string} The URL without prefix
		 */
		urlPrefixRemover: url => {
			let regExpPrefix = new RegExp("(http(s?)://)?");
			let urlFormated = url ? url.replace(regExpPrefix, "") : "";
			return urlFormated;
		},

		getUrlDomain: url => {
			let a = document.createElement("a");
			a.setAttribute("href", url);
			return a.hostname;
		},

		/**
		 * Add url prefix : "https://www." to an url domain
		 * @param {String} url - URL to have prefix added
		 * @return {String} The URL with prefix
		 */
		urlPrefixAdder: url => {
			let urlPrefix = "http://";
			let prefixedUrl = urlPrefix + url;
			return prefixedUrl;
		},

		/**
		 * Reduce the url by removing the 'https' string
		 * @param {string} url - URL to reduce
		 * @return {string} The reduced URL
		 */
		urlReducer: url => {
			return url.split("https://").join("");
		},

		/**
		 * Reset all fields of a form to null
		 * @param {object} form - The object containing the form
		 */
		resetForm: form => {
			for(let [key, value] of Object.entries(form)) {
				value = null; //Filler pour ne pas activer le linter
				form[key] = null;
			}
		},

		/**
		 * Join an array of an object, it's used for export excel tab
		 * @param {arrayKeys} data - it's an array of object.
		 * @param {string} nameValueForm - it's the value to refer for.
		 * @param {string} nameNewValue - it's a new name for the value of the new array.
		 *
		 */

		arrayObjectToString: (data, nameValueForm, nameNewValue) => {
			let copyData = {...data};
			for(let [key, value] of Object.entries(copyData)) {
				/*//console.log(key);*/
				let joinData = value[nameValueForm].join(",");
				/*//console.log(joinData);*/
				value[nameNewValue] = joinData;

			}
			/*//console.log(copyData);*/
		},
		/**
		 * Sort a select with aphabetique value
		 * @param {arrayKeys} data - it's an array of object.
		 * @param {string} fieldName - it's the value to refer for.
		 *
		 */
		sortABC: (data, fieldName) => {
			data.sort((a, b) => {
				return (a[fieldName]).localeCompare(b[fieldName]); //using String.prototype.localCompare()
			});
			return data;
		},

		/**
		 * Convert number to French format
		 * @param {Number} intNumber International formated Number
		 * @return {Number} French formated number
		 */
		convertNumberToFrenchFormat: intNumber => {
			return new Intl.NumberFormat("fr-FR").format(intNumber);
		},

		/**
		 * Convert number to percent French format
		 * @param {Number} intNumber International formated Number
		 * @return {Number} French formated percentage
		 */
		convertNumberToFrenchFormatPercent: intNumber => {
			return new Intl.NumberFormat("fr-FR", {style: "percent"}).format(intNumber);
		},

		/**
		 * Convert international format number to French format with currency
		 * @param {Number} intNumber International formated Number
		 * @return {Number} French formated number
		 */
		convertNumberToFrenchCurrency: intNumber => {
			return new Intl.NumberFormat("fr-FR", {style: "currency", currency: "EUR"}).format(intNumber);
		},
		getSubstractedMonth(month, decreaseValue){
			let month_sub = month - decreaseValue;
			return month_sub >= 0 ? (month_sub + 1) : (13 + month_sub);
		},
		/**
		 * Convert numbers into space 3
		 * @param {Number} intNumber International formated Number
		 * @return {Number} French formated number
		 */
		formatNumberWithSpaces(number) {
			if(number!=null){
				const numStr = String(number);
				const numLength = numStr.length;
				let formattedNumber = "";

				for(let i = 0; i < numLength; i += 3) {
			  const endIndex = numLength - i;
			  const startIndex = Math.max(0, endIndex - 3);
			  const chunk = numStr.slice(startIndex, endIndex);
			  formattedNumber = chunk + " " + formattedNumber;
				}

				return formattedNumber.trim();
			}
			else{
				return "-";
			}
		},

		generateDateRange(strFromDate, strToDate){
			let dates = [];
			let fromDate = new Date(strFromDate);
			let toDate = new Date(strToDate);
			let startMonth = fromDate.getMonth();
			let startYear = fromDate.getFullYear();
			while(startYear <= toDate.getFullYear()){
				if(startYear < toDate.getFullYear()){
					while(startMonth <= 11){
						if(startMonth + 1 < 10){
							dates.push(`${startYear}-0${startMonth + 1}`);
						}
						else{
							dates.push(`${startYear}-${startMonth + 1}`);
						}
						startMonth = startMonth + 1;
					}
				}
				else{
					while(startMonth <= toDate.getMonth()){
						if(startMonth + 1 < 10){
							dates.push(`${startYear}-0${startMonth + 1}`);
						}
						else{
							dates.push(`${startYear}-${startMonth + 1}`);
						}
						startMonth = startMonth + 1;
					}
				}

				startMonth = 0;
				startYear = startYear + 1;
			}

			return dates;
		},

		textBreak(text, numberOfChar){
			let brokenText = "";
			let textLength = text.length;
			for(let i = 0; i < textLength; i += numberOfChar){
				if(i < textLength){
					if(i + numberOfChar <= textLength){
						brokenText += text.slice(i, i + numberOfChar) + "\n";
					}
					else{
						brokenText += text.slice(i, i + (textLength - i));
					}
				}
			}

			return brokenText;
		},
		textWrap(text, numberOfChar){
			if(text.length > numberOfChar){
				return text.substring(0, numberOfChar) + "...";
			}
			else{
				return text;
			}
		},

		research(dataIn, db, key, key1){
			let data = JSON.parse(JSON.stringify(dataIn));
			if(data > 0){
				let num = data;
				for(let x = 0; x < db.length; x++){
					if(db[x][key] == num){
						return db[x][key1];
					}
				}
			}
		},

		dateToFR(dataIn){
			let data = JSON.parse(JSON.stringify(dataIn));
			let re = new RegExp("([T|Z])", "g");
			data = data.replace(re, " ");
			data = data.replace("-", "/");
			let data_date = data.split(" ");
			let data_date_date = data_date[0].split("/");
			let data_date_time = data_date[1];
			let data_date_md = data_date_date[1].split("-");
			return data_date_md[1] + "/" + data_date_md[0] + "/" + data_date_date[0] + " " + data_date_time;
		},
			/**
		 * Set loading with id
		 * @param {Boolean} isLoading 
		 * @param {String} id 
		 * @returns 
		 */
			setLoading(isLoading, id){
				const buttonElement = this.$refs[id].$el;
				if(!isLoading){
					this.$vs.loading.close(this.$refs[id].$el);

					buttonElement.disabled = false;
				}else{
					this.$vs.loading({
						// background: "primary",
						// color: "#fff",
						container: this.$refs[id].$el,
						scale: 0.6,
					});
					buttonElement.disabled = true;
					return this.$refs[id].$el;
					
				}
			},
			/**
			 * 
			 * @param {Boolean} isLoading 
			 * @param {refs} refs - this.$refs["refName"]
			 * @returns 
			 */
			   setLoadingRefs(isLoading, refs){
				console.log(refs);
				   if(!isLoading){
					   this.$vs.loading.close(refs.$el);
	   
				   }else{
					   this.$vs.loading({
						   // background: "primary",
						   // color: "#fff",
						   container: refs.$el,
						   scale: 0.6,
					   });
					   return;
					   
				   }
			   },
			   /**
				* Gives the color of a gradient depending on the value 1 - 100
				* @param {Number} value 
				* @returns 
				*/
			   gradientColor(value) {
	
		
				const green = { r: 40, g: 199, b: 111, a: 1 };
				const yellow = { r: 255, g: 159, b: 67, a: 1 };
				const red = { r: 234, g: 84, b: 85, a: 1 };
				
				const mixColors = (color1, color2, ratio) => {
					const r = Math.round(color1.r * (1 - ratio) + color2.r * ratio);
					const g = Math.round(color1.g * (1 - ratio) + color2.g * ratio);
					const b = Math.round(color1.b * (1 - ratio) + color2.b * ratio);
					return `rgb(${r},${g},${b})`;
				}

				if (value <= 50) {
					const ratio = value / 50;
					return mixColors(green, yellow, ratio);
				} else {
					const ratio = (value - 50) / 50;
					return mixColors(yellow, red, ratio);
				}
			}
			   

	}
	
};
